import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./OwnerWithoutCab.module.scss";

import NavContext from "../../../context/NavContext";

import Button from "../../UiComponents/Button";
import InfosConnexion from "./InfosConnexion";

const OwnerWithoutCab = () => {
  const { ownerProfile, ownerId } = useContext(NavContext);
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.container}>
        <InfosConnexion
          userIsOwner={true}
          ownerName={ownerProfile.display_name}
          login={ownerProfile.user_login}
          email={ownerProfile.user_email}
          date={ownerProfile.user_registered}
          ownerId={ownerId}
        />

        <div className={styles.cabine}>
          <h1>{t("superadmin_ui.no_cabine_yet")}</h1>
          <Button
            onPress={() => window.location.reload()}
            text={t("superadmin_ui.back_to_superadmin")}
            styles={"btnValidation"}
          />
        </div>
      </div>
    </>
  );
};

export default OwnerWithoutCab;
